// GlobalInputField.tsx
import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';

interface GlobalInputFieldProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  icon?: string;
  fullWidth?: boolean;
  autoComplete?: string;
}

export const GlobalInputField: React.FC<GlobalInputFieldProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  type = 'text',
  required = false,
  disabled = false,
  error = '',
  icon,
  fullWidth = true,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === 'password';
  const inputType = isPasswordField && showPassword ? 'text' : type;

  return (
    <div style={{ width: fullWidth ? '100%' : 'auto' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: 600,
          color: error ? '#ef4444' : '#1e3a8a',
          marginBottom: '8px'
        }}>
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </label>
      )}
      
      <div style={{ position: 'relative' }}>
        {icon && (
          <i 
            className={icon} 
            style={{
              position: 'absolute',
              left: '14px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#94a3b8',
              fontSize: '16px',
              pointerEvents: 'none',
              zIndex: 1
            }}
          ></i>
        )}
        
        <InputText
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete}
          style={{
            width: '100%',
            padding: icon ? '12px 14px 12px 42px' : isPasswordField ? '12px 42px 12px 14px' : '12px 14px',
            border: `1px solid ${error ? '#ef4444' : '#e5e7eb'}`,
            borderRadius: '10px',
            fontSize: '14px',
            transition: 'all 0.2s ease',
            background: disabled ? '#f9fafb' : 'white',
            color: disabled ? '#9ca3af' : '#1f2937'
          }}
          className="global-input-field"
        />

        {isPasswordField && (
          <i 
            className={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'} 
            onClick={() => !disabled && setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '14px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#94a3b8',
              fontSize: '16px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              zIndex: 1,
              transition: 'color 0.2s ease',
              opacity: disabled ? 0.5 : 1
            }}
            onMouseEnter={(e) => !disabled && (e.currentTarget.style.color = '#3b82f6')}
            onMouseLeave={(e) => !disabled && (e.currentTarget.style.color = '#94a3b8')}
          ></i>
        )}
      </div>
      
      {error && (
        <span style={{
          display: 'block',
          marginTop: '6px',
          fontSize: '12px',
          color: '#ef4444',
          fontWeight: 500
        }}>
          {error}
        </span>
      )}

      <style>{`
        .global-input-field:enabled:focus {
          outline: 0;
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
        }

        .global-input-field:enabled:hover {
          border-color: #3b82f6 !important;
        }

        .global-input-field:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      `}</style>
    </div>
  );
};